import React, { useEffect, useState } from 'react';
import Modal from '../common/Modal';
import { useVoiceApi } from '../../auth/helper/api/voiceApi';

const VoiceSystemVariablePage = () => {



  const voiceApi = useVoiceApi();

  const [systemVariables, setSystemVariables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false); // State for modal visibility
  const [newSystemVariable, setSystemVariable] = useState({
    variableName: '',
    variableDesc: '',
    variableValue: '',
    variableDefaultValue: '',
    variableRemarks: '',
    status: true, // Default value
  });
  const [editingSystemVariable, setEditingSystemVariable] = useState(null); // Track which system variable is being edited
  const [editValue, setEditValue] = useState(''); // Track edited description
  const [editDescription, setEditDescription] = useState(''); // Track edited description
  const [editDefaultValue, setEditDefaultValue] = useState(''); // Track edited default value
  const [editRemark, setEditRemark] = useState(''); // Track edited remark value

  // State for filters
  const [filters, setFilters] = useState({
    id: null,
    variableName: '',
    variableValue: '',
    status: true, // Default value 
  });

  //for handling pagination
  const [page, setPage] = useState(0); // Starting from the first page
  const [size, setSize] = useState(3); // Number of items per page
  const [totalPages, setTotalPages] = useState(0); // To store total pages

  useEffect(() => {

    const fetchSystemVariables = async () => {
      try {
        const response = await voiceApi.get(
          process.env
            .REACT_APP_GET_ALL_VOICE_SYSTEM_VARIABLES_BY_PAGE_ENDPOINT,
          {
            params: {
              ...filters,
              page,
              size,
            },
          }
        );
        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) { // Check for successful status
          setSystemVariables(object.content); // Set the templates from the response object
          setTotalPages(object.totalPages);
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching systemVariables:', err);
        setError(err.message || 'An error occurred.');
        setLoading(false);

      }
    };

    fetchSystemVariables();
  }, [voiceApi, page, size]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSystemVariable((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditClick = (systemVariable) => {
    // Set the system variable being edited
    setEditingSystemVariable(systemVariable.id);
    setEditValue(systemVariable.variableValue)//set value to edit
    setEditDescription(systemVariable.variableDesc); // Set the description to edit
    setEditDefaultValue(systemVariable.variableValue); //set the default vaule to edit
    setEditRemark(systemVariable.variableRemarks);//set the remarks
  };

  const handleEditSubmit = async (systemVariableId) => {

    try {
      // Update systemVariable with PUT request

      await voiceApi.put(
        `${process.env.REACT_APP_PUT_VOICE_SYSTEM_VARIABLE_ENDPOINT}/${systemVariableId}`,
        {
          variableValue: editValue, // value field
          variableDesc: editDescription, // the description field is updated
          variableDefaultValue: editDefaultValue, // the default value is updated
          variableRemarks: editRemark,
        }
      );

      // Refresh the systemVariables list after the update
      const updatedSystemVariables = systemVariables.map((systemVariable) => {
        if (systemVariable.id === systemVariableId) {
          return { ...systemVariable, variableValue: editValue, variableDesc: editDescription, variableDefaultValue: editDefaultValue, variableRemarks: editRemark }; // Update the edited system variable
        }
        return systemVariable; // Keep the other records unchanged
      });
      setSystemVariables(updatedSystemVariables);
      setEditingSystemVariable(null); // Reset editing state
      setEditValue(''); //clear
      setEditDescription(''); // Clear edit description 
      setEditDefaultValue(''); //clear
      setEditRemark('');//clear
    } catch (err) {
      setError(err.message || 'An error occurred while updating the Template variable.');
    }
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    try {
      const response = await voiceApi.post(
        `${process.env.REACT_APP_SET_VOICE_SYSTEM_VARIABLE_ENDPOINT}`,
        newSystemVariable
      );
      if (response.status === 200) {
        setSystemVariables((prev) => [...prev, response.data.object]); // Update with new systemVariable
        setSystemVariable({
          variableName: '',
          variableDesc: '',
          variableValue: '',
          variableDefaultValue: '',
          variableRemarks: '',
          status: true, // Default value
        });
        setError(null);
        setModalOpen(false); // Close modal after submission
      } else {
        setError(`Error: ${response.data.message}`);
      }
    } catch (err) {
      setError(err.message || 'An error occurred while creating the systemVariable.');
    }
  };

  const handleFilterInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => {
      const newFilters = { ...prev, [name]: value };
      return newFilters;
    });
  };

  // Handle the status change to convert to boolean
  const handleStatusChange = (e) => {
    const value = e.target.value;
    const statusValue = value === 'Active' ? true : value === 'Inactive' ? false : null;

    setFilters((prev) => {
      const newFilters = { ...prev, status: statusValue };
      return newFilters;
    });
  };


  const toggleActivationStatus = async (systemVariableId, currentStatus) => {

    try {
      const newStatus = !currentStatus; // Toggle the current status
      await voiceApi.patch(
        `${process.env.REACT_APP_SET_VOICE_SYSTEM_VARIABLE_STATUS_ENDPOINT}/${systemVariableId}`,
        { status: newStatus }
      );
      setSystemVariables((prev) =>
        prev.map((systemVariable) => systemVariable.id === systemVariableId ? { ...systemVariable, status: newStatus } : systemVariable)
      );
    } catch (err) {
      setError(err.message || 'An error occurred while updating the status.');
    }
  };

  // New function to apply filters
  const applyFilters = async () => {

    setLoading(true); // Show loading while fetching filtered notifications
    try {

      const response = await voiceApi.get(
        process.env
          .REACT_APP_GET_ALL_VOICE_SYSTEM_VARIABLES_BY_PAGE_ENDPOINT,
        {
          params: {
            ...filters,
            page,
            size,
          },
        }
      );
      // Extract data from the response
      const { message, object, httpStatus } = response.data;

      if (httpStatus === 200) { // Check for successful status
        setSystemVariables(object.content); // Set the templates from the response object
        setTotalPages(object.totalPages);
      } else {
        setError(`Error: ${message}`); // Handle non-success status code
      }

      setLoading(false);
    } catch (err) {
      console.error('Error fetching systemVariables:', err);
      setError(err.message || 'An error occurred.');
      setLoading(false);

    }
  };

  const handleNextPage = () => {
    if (page + 1 < totalPages) {
      setPage((prevPage) => prevPage + 1); // Increment page number
    }
  };

  const handlePreviousPage = () => {
    if (page > 0) {
      setPage((prevPage) => prevPage - 1); // Decrement page number
    }
  };

  const handleSizeChange = (e) => {
    setSize(e.target.value);
    setPage(0); // Reset to first page on changing size
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="template-variable-container">
      <h2>Voice System Variables</h2>
      <div className="flex-row filter-section">
        <div className='filter-item'>
          <label htmlFor="items-per-page">Items per page: </label>
          <select id="items-per-page" onChange={handleSizeChange} className="w-auto">
            <option value={3}>default</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={5}>5</option>
            <option value={10}>10</option>
          </select>
        </div>
      </div>
      <h3>Filters</h3>
      {/* Filter Form */}
      <div className="flex-row filter-section">
        <div className="filter-item">
          <label>Id:</label>
          <input
            type="text"
            name="id"
            value={filters.id ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>Name:</label>
          <input
            type="text"
            name="variableName"
            value={filters.variableName ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>Value:</label>
          <input
            type="text"
            name="variableValue"
            value={filters.variableValue ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>Status:</label>
          <select name="status" onChange={handleStatusChange} value={filters.status === null ? '' : filters.status ? 'Active' : 'Inactive'}>
            <option value="">All</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        <button type="button" onClick={applyFilters}>Apply Filters</button>

      </div>

      {/* Button to open the modal */}
      <button onClick={() => setModalOpen(true)}>+ Create New</button>

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
        <div className="page-container">
          <h3>Create New Voice system Variable</h3>
          <form onSubmit={handleSubmit} className="standard-form">
            <div className="form-group">
              <label>Name:</label>
              <input
                type="text"
                name="variableName"
                value={newSystemVariable.variableName}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Value:</label>
              <input
                type="text"
                name="variableValue"
                value={newSystemVariable.variableValue}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Description:</label>
              <input
                type="text"
                name="variableDesc"
                value={newSystemVariable.variableDesc}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Default value:</label>
              <input
                type="text"
                name="variableDefaultValue"
                value={newSystemVariable.variableDefaultValue}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Remarks:</label>
              <input
                type="text"
                name="variableRemarks"
                value={newSystemVariable.variableRemarks}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Activation Status:</label>
              <input
                type="checkbox"
                name="status"
                checked={newSystemVariable.status}
                onChange={handleInputChange}
              />
            </div>

            <button type="submit">Create System Variable</button>
          </form>
        </div>
      </Modal>

      <h3>Existing Voice System Variables</h3>
      {systemVariables.length === 0 ? (
        <p>No System Variables available</p>
      ) : (
        <div className="table-responsive">
          <table className="notifications-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Value</th>
                <th>Description</th>
                <th>Default</th>
                <th>Remark</th>
                <th>Created At</th>
                <th>Status</th>
                <th>Last Updated At</th>
                <th>Last Updated By</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {systemVariables.map((systemVariable) => (
                <tr key={systemVariable.id}>
                  <td>{systemVariable.id}</td>
                  <td>{systemVariable.variableName}</td>
                  <td>
                    {editingSystemVariable === systemVariable.id ? (
                      <input
                        type="text"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)} // Handle edit value change
                      />
                    ) : (
                      systemVariable.variableValue
                    )}
                  </td>
                  <td>
                    {editingSystemVariable === systemVariable.id ? (
                      <input
                        type="text"
                        value={editDescription}
                        onChange={(e) => setEditDescription(e.target.value)} // Handle edit description change
                      />
                    ) : (
                      systemVariable.variableDesc
                    )}
                  </td>
                  <td>
                    {editingSystemVariable === systemVariable.id ? (
                      <input
                        type="text"
                        value={editDefaultValue}
                        onChange={(e) => setEditDefaultValue(e.target.value)} // Handle edit Default change
                      />
                    ) : (
                      systemVariable.variableDefaultValue
                    )}
                  </td>
                  <td>
                    {editingSystemVariable === systemVariable.id ? (
                      <input
                        type="text"
                        value={editRemark}
                        onChange={(e) => setEditRemark(e.target.value)} // Handle edit Remark change
                      />
                    ) : (
                      systemVariable.variableRemarks
                    )}
                  </td>
                  <td>{new Date(systemVariable.createdTimestamp).toLocaleString()}</td>
                  <td>{systemVariable.status ? 'Active' : 'Inactive'}</td>
                  <td>{new Date(systemVariable.updatedTimestamp).toLocaleString()}</td>
                  <td>{systemVariable.lastUpdatedBy}</td>
                  <td>
                    <div className="action-buttons">
                      {editingSystemVariable === systemVariable.id ? (
                        <button onClick={() => handleEditSubmit(systemVariable.id)}>Save</button> // Save edited voice system variable
                      ) : (
                        <button onClick={() => handleEditClick(systemVariable)}>Edit</button> // Set voice system variable to edit
                      )}
                      <button onClick={() => toggleActivationStatus(systemVariable.id, systemVariable.status)}>
                        {systemVariable.status ? 'Disable' : 'Enable'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Pagination Controls */}
      <div className="pagination-container">
        <button onClick={handlePreviousPage} disabled={page === 0}>Previous</button>
        <span>Page {page + 1} of {totalPages}</span>
        <button onClick={handleNextPage} disabled={page + 1 === totalPages}>Next</button>
      </div>
    </div>
  );
};

export default VoiceSystemVariablePage;
